import React from 'react';
import { Redirect } from 'expo-router';
export default function LocalDeckFallback() { return <Redirect href="/deck" />; }
